// src/features/system/orchestrator/api/workflowsV2Api.ts
import { bff } from '@/lib/http/bff';

export interface StartWorkflowResponse {
  workflow_run_id: string;
  workflow_id: string;
  status: string;
}

export type WorkflowCatalogRowV2 = {
  workflow_key: string;
  version: number;
  definition?: unknown;
  metadata?: Record<string, unknown>;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
};

export interface ListWorkflowsV2Response {
  as_of?: string;
  items: WorkflowCatalogRowV2[];
  next_cursor?: string | null;
}

export interface ListWorkflowsV2Params {
  limit?: number;
  cursor?: string;
  tenant_id?: number;
  // Escape hatch if the workflow saves a different outcome_key.
  outcome_key?: string;
}

export const fetchWorkflowsV2Api = (params: ListWorkflowsV2Params = {}): Promise<ListWorkflowsV2Response> =>
  bff.get<ListWorkflowsV2Response>('/orchestrator/workflow-catalog/v2', params as any);

export interface PublishWorkflowV2Input {
  workflow_key: string;
  version: number;
  definition: unknown;
  metadata?: Record<string, unknown>;
  is_active?: boolean;
}

export const publishWorkflowV2Api = (payload: PublishWorkflowV2Input): Promise<StartWorkflowResponse> =>
  bff.post<StartWorkflowResponse>('/orchestrator/workflow-catalog/v2/publish', payload);

export interface TriggerWorkflowV2Input {
  workflow_key: string;
  version?: number;
  inputs?: Record<string, unknown>;
  run_metadata?: Record<string, unknown>;
}

// Outcomes-first run/trigger: resolves workflow spec from outcomes and starts inline dag.
export const triggerWorkflowV2Api = (payload: TriggerWorkflowV2Input): Promise<StartWorkflowResponse> =>
  bff.post<StartWorkflowResponse>('/orchestrator/workflows/trigger/v2', payload);
